import { render, staticRenderFns } from "./Colore.vue?vue&type=template&id=080ddb9c&"
import script from "./Colore.vue?vue&type=script&lang=js&"
export * from "./Colore.vue?vue&type=script&lang=js&"
import style0 from "./Colore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports